<script>
	import arrow_left from '$lib/assets/arrow_left_white.png';
	import arrow_right from '$lib/assets/arrow_right_white.png';
	import { resource } from '$lib/utils.js';
	import { Splide, SplideSlide, SplideTrack } from '@splidejs/svelte-splide';
	import { onMount } from 'svelte';
	export let data;
	export let active;
	let swiper;

	const options = {
		type: 'fade',
		pagination: false,
		perPage: 1,
		perMove: 1,
		snap: true
	};

	onMount(() => {
		if (active) {
			swiper.splide.Components.Controller.go(active);
		}
		swiper.splide.on('moved', stopCurrentPlayer);
	});

	const stopCurrentPlayer = () => {
		const videos = document.querySelectorAll('video');
		videos.forEach((video) => {
			if (!video.paused) {
				video.pause();
				video.currentTime = 0;
			}
		});

		const iframes = document.querySelectorAll('iframe');
		iframes.forEach((iframe) => {
			const src = iframe.src;
			iframe.src = src;
		});
	};
</script>

<Splide
	hasTrack={false}
	{options}
	bind:this={swiper}
	aria-labelledby="gallery"
	class="gallery"
	useIndex={true}
>
	<div class="splide__arrows">
		<button class="splide__arrow splide__arrow--prev">
			<img src={arrow_left} alt="arrow" />
		</button>
		<button class="splide__arrow splide__arrow--next">
			<img src={arrow_right} alt="arrow" />
		</button>
	</div>
	<div>
		<SplideTrack>
			{#each data as file}
				<SplideSlide>
					{#if file?.field_media?.type == 'media--video' || file?.field_gallery_item?.type == 'media--video'}
						<!-- svelte-ignore a11y-media-has-caption -->
						<video playsinline controls class="js-player aspect-video">
							<source
								src={resource(
									file?.field_media
										? file?.field_media?.field_media_video_file?.uri?.url
										: file?.field_gallery_item?.field_media_video_file?.uri?.url
								)}
								type="video/webm"
							/>
						</video>
					{:else if file?.field_media?.type == 'media--remote_video' || file?.field_gallery_item?.type == 'media--remote_video'}
						<div class="w-full h-full aspect-video">
							<div
								class="aspect-video player"
								data-plyr-provider="youtube"
								data-plyr-embed-id={file?.field_media?.field_media_oembed_video ||
									file?.field_gallery_item?.field_media_oembed_video}
							/>
						</div>
					{:else}
						<!-- svelte-ignore a11y-img-redundant-alt -->
						<img
							class="object-contain w-full h-full"
							src={resource(file?.field_media?.field_media_image?.uri?.url)}
							alt="image"
							loading="lazy"
						/>
					{/if}
				</SplideSlide>
			{/each}
		</SplideTrack>
	</div>
</Splide>

<style>
	.splide__arrow {
		background: transparent !important;
	}
	:global(.gallery .splide__slide) {
		overflow: hidden !important;
		display: flex;
		align-items: center;
		justify-content: center;
		max-height: 550px;
	}
	:global(.gallery .plyr) {
		min-width: auto;
	}
	:global(.gallery .splide__arrow) {
		height: 40%;
	}
</style>
